export const raceConditionChecker = () => {
  const _tasks: Map<
    number,
    { actionName: string; mutations: { [key: string]: string } }
  > = new Map();

  const addAction = (actionName: string, actionId: number) => {
    if (!_tasks.has(actionId)) {
      _tasks.set(actionId, { actionName, mutations: {} });
    }
  };

  const _checkRaceCondition = (mutationId: string): {
    hasRaceCondition: boolean;
    items: Array<{ actionName: string; mutationName: string }>;
  } => {
    const allMutations = Array.from(_tasks.entries()).map(([, val]) => val)
      .flat();
    const items = allMutations.filter(({ mutations }) => mutations[mutationId]);
    return {
      hasRaceCondition: items.length > 1,
      items: items.map((f) => ({
        actionName: f.actionName,
        mutationName: f.mutations[mutationId],
      })),
    };
  };

  const addMutation = (
    actionId: number,
    stateName: string,
    mutationName: string,
    effectingProp: string,
  ) => {
    const mutationId = stateName + "/" + mutationName; //effectingProp;
    const action = _tasks.get(actionId);
    if (action) {
      _tasks.set(actionId, {
        ...action,
        mutations: {
          ...action.mutations,
          [mutationId]: mutationName,
        },
      });
    }
    const { items, hasRaceCondition } = _checkRaceCondition(mutationId);
    if (hasRaceCondition) {
     /*  console.warn(
        mutationId,
        //  effect the same property: ${effectingProp} and
        `the following mutations are in a race condition :

         ${
          items.map(({ actionName, mutationName }, index) =>
            `${index}. ${mutationName} exec in ${actionName}\n`
          ).reduce((acc, str) => {
            acc += str;
            return acc;
          }, ``)
        }
        `,
      ); */
    }
  };

  const removeAction = (actionId: number) => _tasks.delete(actionId);

  return {
    addAction,
    addMutation,
    removeAction,
  };
};
